export default {
  default_program_name: 'Belønningsklub',
  message:
    'Bliv medlem af <highlight>{{name}}</highlight> – optjen {{reward}} for hver {{spend}}, du bruger, og få adgang til gratis menupunkter!',
  buttons: {
    join_now: 'Tilmeld dig nu',
  },
};
